/**
 * Provides access to a global event bus for federated applications.
 *
 * @returns {Object} An object containing the global event bus.
 *
 * @description
 * This composable retrieves the global event bus from the window object:
 * - Supports communication between different parts of a federated application
 * - Allows publishing and subscribing to events across components
 * - Provides a centralized event management mechanism
 *
 * @example
 * // Access the event bus
 * const { eventBus } = useFederatedEventBus()
 *
 * @remarks
 * - Only works in client-side environments
 * - Requires the event bus to be defined on the window object
 * - TypeScript type checking is disabled for window.eventBus
 * - Primarily used in micro-frontend or federated application architectures
 */
export const useFederatedEventBus = () => {
  // @ts-ignore
  const eventBus = window?.eventBus

  return {
    eventBus,
  }
}
